import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './context/ProtectedRoute';
import PublicRoute from './context/PublicRoute';

// Import all your components
import Home from './pages/Home';
import OurProfile from './pages/About/OurProfile';
import OurService from './pages/OurApproach/OurService';
import './App.css';
import FinancialCalculator from './pages/InvestZone/FinancialCalculator';
import VideoTutorial from './pages/InvestZone/VideoTutorial';
import TestmonialPage from './pages/Grievance/TestmonialPage';
import Certificate from './pages/About/Certificate';
import BlogsPage from './pages/Blogs/BlogsPage';
import KycPage from './pages/InvestZone/KycPage';
import AwardGalleyPage from './pages/InvestZone/AwardGalleryPage';
import ImportantLinksPage from './pages/Footer/ImportantLinksPage';
import DisclaimerPage from './pages/Footer/DisclaimerPage';
import PrivacyPolicyPage from './pages/Footer/PrivacyPolicyPage';
import TermsConditionsPage from './pages/Footer/TermsConditionsPage';
import CookiePolicyPage from './pages/Footer/CookiePolicyPage';
import DisclosurePage from './pages/Footer/DisclosurePage';
import OurTeam from './pages/About/OurTeam';
import AdminLogin from './pages/Admin/AdminLogin'; 
import AdminPanel from './pages/Admin/AdminPanel';
import AdminSignupPage from './pages/Admin/AdminSignUpPage';
import AdminVideoUpload from './pages/Admin/AdminVideoUpload';
import TeamImageUpload from './pages/Admin/TeamImageUpload';
import RiskProfilePage from './pages/RiskProfile/RiskProfilePage';
import RiskProfileCreatePage from './pages/Admin/RiskProfileCreatePage';
import RiskProfileAdminDashboard from './pages/Admin/RiskProfileAdminDashboard';
import OurCulture from './pages/About/OurCulture';
import BlogAdminUpload from './pages/Admin/BlogAdminUpload';

import InvesterAwarenessPage from './pages/InvestZone/InvesterAwarenessPage';
import ContactUs from './pages/About/ContactUs';
import OurApproach from './pages/OurApproach/OurApproach';
import OurStrategies from './pages/OurApproach/OurStratergies';
import OurPrinciples from './pages/OurApproach/OurPrinciples';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Public Routes - No authentication required */}
            <Route path="/" element={<Home />} />
            <Route path="/about/profile" element={<OurProfile />} />
            <Route path="/service" element={<OurService />} />
            <Route path="/about/team" element={<OurTeam />} />
            <Route path="/about/contact" element={<ContactUs />} />
            <Route path="/about/culture" element={<OurCulture />} />
            <Route path="/ourapproach" element={<OurApproach />} />
            <Route path="/principles" element={<OurPrinciples />} />
            <Route path="/blogs" element={<BlogsPage />} />
            <Route path="/investzone/kyc" element={<KycPage />} />
            <Route path="/investzone/awardgallery" element={<AwardGalleyPage />} />
            <Route path="/about/certificate" element={<Certificate />} />
            <Route path="/investzone/investerawareness" element={<InvesterAwarenessPage />} />
            <Route path="/investzone/financialcalculator" element={<FinancialCalculator />} />
            <Route path="/investzone/videotutorial" element={<VideoTutorial />} />
            <Route path="/testimonial" element={<TestmonialPage />} />
            <Route path="/riskprofile" element={<RiskProfilePage />} />
            <Route path="/important-links" element={<ImportantLinksPage />} />
            <Route path="/disclaimer" element={<DisclaimerPage />} />
            <Route path="/disclosure" element={<DisclosurePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-conditions" element={<TermsConditionsPage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            <Route path="/stratergies" element={<OurStrategies />} /> {/* Assuming this is a placeholder for strategies */}

            {/* Admin Login Route - Public but redirects if already logged in */}
            <Route 
              path="/admin" 
              element={
                <PublicRoute>
                  <AdminLogin />
                </PublicRoute>
              } 
            />

            {/* Protected Admin Routes - Require authentication and admin role */}
            <Route 
              path="/adminportal" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminPanel />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/adminportal/videotutorialupload" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminVideoUpload />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/adminportal/teamimageupload" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <TeamImageUpload />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/adminportal/blogupload" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <BlogAdminUpload />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/adminportal/signup" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminSignupPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/adminportal/riskprofilecreate" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <RiskProfileCreatePage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/adminportal/riskprofileadmin" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <RiskProfileAdminDashboard />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;